module.exports = __webpack_public_path__ + "static/img/OOSH_065.54a5ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_065.jpg
// module id = WWbj
// module chunks = 170